<template>
    <div id="contact-form">
        <div class="linear-form-gradient px-3 py-4 pt-10 md:p-10 lg:grid md:grid-cols-12 md:gap-16">
            <div class="col-start-1 col-span-6">
                <div class="space-y-4">
                    <div class="text-bigger-size font-semibold">
                        Não encontrou a sua vaga?
                    </div>
                    <div class="text-medium-size ">
                        Cadastre o seu currículo e entraremos em contato quando uma nova oportunidade aparecer.
                    </div>
                </div>
            </div>
            <div class="col-start-7 col-span-6">
                <form
                    method="POST"
                    enctype="multipart/form-data"
                    class="grid grid-cols-12 gap-6 mt-10 md:mt-0 form-contact"
                    @submit.prevent="submit"
                >
                    <input v-model="form.name" required type="text" name="name" placeholder="Nome" class="col-start-1 col-span-12 md:col-start-1 md:col-span-6">
                    <input v-model="form.role" required type="text" name="role" placeholder="Cargo" class="col-start-1 col-span-12 md:col-start-7 md:col-span-6">
                    <input v-model="form.phone" required type="tel" name="phone" placeholder="Telefone" class="col-start-1 col-span-12 md:col-start-1 md:col-span-4 m-0">
                    <input v-model="form.email" required type="email" name="email" placeholder="Email*" class="col-start-1 col-span-12 md:col-start-5 md:col-span-8">
                    <input v-model="form.portfolio" required type="url" name="portfolio" placeholder="Link do currículo / Github" class="col-start-1 col-span-12">
                    <textarea v-model="form.message" required name="message" placeholder="Sua mensagem" rows=1 cols="60" class="col-start-1 col-span-12"></textarea>
                    <div class="col-start-1 col-span-12 overflow-hidden">
                        <recaptcha />
                    </div>
                    <div class="col-span-12 my-5">
                        <div class="flex items-center justify-center md:justify-end gap-4">
                            <Transition
                                enter-active-class="transition ease-in-out"
                                enter-from-class="opacity-0"
                                leave-active-class="transition ease-in-out"
                                leave-to-class="opacity-0"
                            >
                                <div v-if="form.recentlySuccessful" class="col-span-1 flex justify-center md:justify-end">
                                    Enviado com sucesso!
                                </div>
                            </Transition>

                            <button
                                type="submit"
                                class="button-outlined-white"
                                :disabled="form.processing"
                            >
                                {{ form.processing ? 'Enviando...' : 'Enviar' }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3';

const form = useForm({
    name: '',
    role: '',
    phone: '',
    email: '',
    portfolio: '',
    message: '',
});

const submit = () => {
    form.post(route('JobApplication'), {
        preserveScroll: true
    });
}
/*
import formPortfolioSubmitHandler from "../../../components/utils/FormPortfolioSubmitHandler.js"
export default {
    mixins:[formPortfolioSubmitHandler],
    data(){
        return {
        name:'',
        role:'',
        phone:'',
        email:'',
        message:'',
        portfolio:'',
    }
    },
}
*/
</script>
<style lang="postcss" scoped>
.button-outlined-white:disabled {
    cursor: default !important;
}

.linear-form-gradient {
    color: hsla(0, 0%, 100%, 1);
    border-radius: 20px 20px 0 0;

    & .text-bigger-size {
        letter-spacing: 0.02rem;
    }
}

.form-contact{
    & input {
        background-color: inherit;
    }

    & textarea {
        @apply pb-1;
        &::-webkit-scrollbar {
            display: none;
        }

        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    & ::placeholder, & label {
        @apply text-white text-xl;
    }

    &::-ms-input-placeholder {
        @apply text-white  text-xl;
    }

    &:-ms-input-placeholder {
        @apply text-white  text-xl;
    }

    &>:nth-child(-n+6) {
        background: none;
        border-bottom: 0.5px solid #FFF;

        &:focus{
            outline: none;
        }

        @apply text-white mb-3;
    }

}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active{
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: white !important;
    font-size: 100%;
    @apply font-semibold;
}
</style>
